import audio from '@/assets/images/png/audio.png';
import books from '@/assets/images/png/books.png';
import course from '@/assets/images/png/course.png';
import docs from '@/assets/images/png/docs.png';
import people from '@/assets/images/png/people.png';
import video from '@/assets/images/png/video.png';
import { ResourceTypes } from '@/models/resources';

export const resourceImage = {
  [ResourceTypes.Podcast]: audio,
  [ResourceTypes.Book]: books,
  [ResourceTypes.Video]: video,
  [ResourceTypes.EventOrLecture]: people,
  [ResourceTypes.Document]: docs,
  [ResourceTypes.Course]: course,
  [ResourceTypes.Others]: docs,
};
